import _ from 'lodash';

export const arePropsFilterEqual = (prevProps: any, nextProps: any) => _.isEqual(prevProps.filter, nextProps.filter);
